/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
var subDomain = "api";
if (window.location.host != "www.startfreept.com" && window.location.host != "startfreept.com") {
  subDomain = "uatapi";
}

export const URL = "https://" + subDomain + ".virdiohealth.com/api/v1/assessment/analyze";
export const URLPlan = "https://" + subDomain + ".virdiohealth.com/api/v1/assessment/sendPlan";
export const BETA_URL = "https://" + subDomain + ".virdiohealth.com/api/v1/assessment/betaAccess";

export const LOGO = "https://virdiodev.s3.us-east-2.amazonaws.com/sampleVideo/startfreept_logo.svg";
export const LOGO_PLACEHOLDER = "https://placehold.co/128x32/e2e8f0/475569?text=Logo";
export const HOME_VIDEO = "https://virdiodev.s3.us-east-2.amazonaws.com/sampleVideo/WelcomeToStartFreePTv2.0.mp4";
export const HOME_VIDEO_2 = "https://virdiodev.s3.us-east-2.amazonaws.com/sampleVideo/HeroVideo-v13.0.mp4";
export const SKELETON = "https://virdiodev.s3.us-east-2.amazonaws.com/sampleVideo/VH-Bodyoutline.png";
export const SKELETON_PLACEHOLDER = "https://placehold.co/250x500/e2e8f0/475569?text=Body+Outline";

// Modified for Floor & Attributes on Aug 10th 2025

// First videos
export const SeatedTrunkRotation = "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/SeatedTrunkRotationv1.0.mp4";
export const SupineDoubleKneeToChest = "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/SupineDoubleKneeToChestROMv1.0.mp4";
export const StandingSideBend = "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/SideToSideBendv1.0.mp4";
export const StandingLumbarExtension = "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/StandingLumbarExtensionROMv1.0.mp4";
export const SeatedSingleKneeToChest = "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/SeatedSingleKneeToChestv1.0.mp4";
export const ToeTouch = "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/ToeTouchv1.0.mp4";
export const PronePressUp = "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/PronePressUpROMv1.0.mp4";

// Negative videos
export const SeatedTrunkRotationNeg = "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/SeatedTrunkRotationvNegative1.0.mp4";
export const PronePressUpNeg = "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/PronePressUpROMNegativev1.0.mp4";
export const ToeTouchNeg = "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/ToeTouchNegativeTestv1.0.mp4";
export const StandingLumbarExtensionNeg = "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/StandingLumbarExtensionROM-Negativev1.0.mp4";
// ============================================================
// Purpose: When First Test = "Felt Worse", skip Second Test
//          and set final diagnosis to this fallback subtype
// ============================================================
export const OVERRIDE_TARGETS = {
  HIP: 'PELVIC_CONTROL_IMPAIRMENT',
  THIGH: 'HAMSTRING_LOADING_LENGTHENING_DEFICIT',  // CHANGED from NERVE_GLIDING_DYSFUNCTION (no non-floor exercises)
  KNEE: 'LIMITED_KNEE_EXTENSION_FLEXION_MOBILITY',
};

// ============================================================
// SAFETY SCREENING QUESTIONS - Problem Area Specific
// Purpose: Screen for conditions requiring provider referral
// Display: After Pain Location, before CPG Question
// ============================================================

export const SAFETY_QUESTIONS = {
  HIP: {
    prompt: "Do any of the following apply to you?",
    options: [
      {
        id: "hip-safety-none",
        label: "None of these apply to me",
        value: "CLEAR",
        routesTo: "continue"
      },
      {
        id: "hip-safety-childhood",
        label: "I was diagnosed with a childhood hip condition (such as Perthes disease or a slipped hip)",
        value: "EXCLUDE",
        routesTo: "referral"
      },
      {
        id: "hip-safety-avn",
        label: "I have been told I have avascular necrosis or bone death in my hip",
        value: "EXCLUDE",
        routesTo: "referral"
      },
      {
        id: "hip-safety-replacement",
        label: "I have had a hip replacement or major hip surgery in the past 6 months",
        value: "EXCLUDE",
        routesTo: "referral"
      },
      {
        id: "hip-safety-trauma",
        label: "My hip pain started after a fall or significant injury",
        value: "EXCLUDE",
        routesTo: "referral"
      },
    ]
  },
  THIGH: {
    prompt: "Do any of the following apply to you?",
    options: [
      {
        id: "thigh-safety-none",
        label: "None of these apply to me",
        value: "CLEAR",
        routesTo: "continue"
      },
      {
        id: "thigh-safety-trauma",
        label: "My thigh pain started after a fall, direct hit, or other injury",
        value: "EXCLUDE",
        routesTo: "referral"
      },
      {
        id: "thigh-safety-surgery",
        label: "I have had leg or thigh surgery in the past 3 months",
        value: "EXCLUDE",
        routesTo: "referral"
      },
    ]
  },
  KNEE: {
    prompt: "Do any of the following apply to you?",
    options: [
      {
        id: "knee-safety-none",
        label: "None of these apply to me",
        value: "CLEAR",
        routesTo: "continue"
      },
      {
        id: "knee-safety-surgery-recent",
        label: "I have had knee surgery in the past 3 months",
        value: "EXCLUDE",
        routesTo: "referral"
      },
      {
        id: "knee-safety-trauma",
        label: "My knee pain started after a fall, twist, or direct injury",
        value: "EXCLUDE",
        routesTo: "referral"
      },
      {
        id: "knee-safety-ligament",
        label: "I have been told I have a torn ligament (ACL, PCL, MCL) that has not been treated",
        value: "EXCLUDE",
        routesTo: "referral"
      },
    ]
  }
};
export const PLACEHOLDER_VIDEO = "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/PLACEHOLDER.mp4";


export const ZONES = [
  { id: "LOWER_BACK_LEFT", label: "L Back", name: "Left Lower Back", style: { width: "46px", height: "42px", top: "191px", left: "75px" } },
  { id: "LOWER_BACK_RIGHT", label: "R Back", name: "Right Lower Back", style: { width: "46px", height: "42px", top: "191px", left: "129px" } },
  { id: "BUTTOCK_LEFT", label: "L Buttock", name: "Left Buttock", style: { width: "50px", height: "42px", top: "233px", left: "73px" } },
  { id: "BUTTOCK_RIGHT", label: "R Buttock", name: "Right Buttock", style: { width: "50px", height: "42px", top: "233px", left: "127px" } },
  { id: "THIGH_LEFT", label: "L Thigh", name: "Left Thigh", style: { width: "50px", height: "75px", top: "275px", left: "73px" } },
  { id: "THIGH_RIGHT", label: "R Thigh", name: "Right Thigh", style: { width: "50px", height: "75px", top: "275px", left: "127px" } },
  { id: "LEG_LEFT", label: "L Leg", name: "Left Lower Leg", style: { width: "42px", height: "83px", top: "329px", left: "79px" } },
  { id: "LEG_RIGHT", label: "R Leg", name: "Right Lower Leg", style: { width: "42px", height: "83px", top: "329px", left: "129px" } },
];
// ═══════════════════════════════════════════════════════
// Zone button labels per tab (left and right sides)
// ═══════════════════════════════════════════════════════
export const ZONE_BUTTONS = {
  LBP: { left: ['Lower Back', 'Buttock', 'Thigh', 'Lower Leg'], right: ['Lower Back', 'Buttock', 'Thigh', 'Lower Leg'] },
  HIP: { left: ['Lower Back', 'Buttock', 'Front/Groin', 'Side Hip', 'Thigh', 'Knee'], right: ['Lower Back', 'Buttock', 'Front/Groin', 'Side Hip', 'Thigh', 'Knee'] },
  THIGH: { left: ['Back', 'Buttock', 'Hip', 'Back Thigh', 'Front Thigh', 'Inner Thigh', 'Outer Thigh', 'Knee'], right: ['Back', 'Buttock', 'Hip', 'Back Thigh', 'Front Thigh', 'Inner Thigh', 'Outer Thigh', 'Knee'] },
  KNEE: { left: ['Back', 'Buttock', 'Hip', 'Thigh', 'Front Knee', 'Back Knee', 'Inner Knee', 'Outer Knee'], right: ['Back', 'Buttock', 'Hip', 'Thigh', 'Front Knee', 'Back Knee', 'Inner Knee', 'Outer Knee'] },
};

// ═══════════════════════════════════════════════════════
// Calibrated regions — LEFT side coords per tab
// RIGHT side = auto-mirrored via mirrorCoords()
// All values in % of image dimensions [x%, y%, w%, h%]
// ═══════════════════════════════════════════════════════
const LBP_L = {
  'Lower Back': [36.5, 33.5, 12.0, 8.0],
  'Buttock': [36.1, 45.5, 12.8, 7.8],
  'Thigh': [36.8, 57.0, 11.4, 12.0],
  'Lower Leg': [37.5, 74.5, 10.0, 14.0],
};
const HIP_L = {
  'Lower Back': [36.8, 38.0, 12.0, 6.2],
  'Buttock': [37.2, 46.8, 12.7, 3.8],
  'Front/Groin': [37.2, 51.1, 11.3, 4.0],
  'Side Hip': [31.0, 46.8, 5.5, 6.5],
  'Thigh': [37.2, 58.8, 10.5, 10.0],
  'Knee': [37.5, 69.5, 10.0, 5.0],
};
const THIGH_L = {
  'Back': [35.8, 36.5, 13.3, 6.5],
  'Buttock': [36.5, 47.0, 12.0, 7.0],
  'Hip': [31.0, 45.0, 5.0, 9.0],
  'Back Thigh': [37.2, 56.0, 10.5, 5.0],
  'Front Thigh': [37.2, 61.0, 10.5, 5.0],
  'Inner Thigh': [47.7, 56.0, 4.2, 10.0],
  'Outer Thigh': [31.6, 56.0, 4.2, 10.0],
  'Knee': [37.5, 69.5, 10.0, 5.0],
};
const KNEE_L = {
  'Back': [36.7, 36.5, 11.6, 6.5],
  'Buttock': [36.5, 47.0, 12.0, 7.0],
  'Hip': [31.0, 45.0, 5.0, 9.0],
  'Thigh': [37.2, 57.0, 10.5, 11.0],
  'Front Knee': [37.5, 69.5, 10.0, 2.5],
  'Back Knee': [37.5, 72.0, 10.0, 2.5],
  'Inner Knee': [47.5, 69.5, 3.5, 5.0],
  'Outer Knee': [32.5, 69.5, 3.5, 5.0],
};

function mirrorCoords(left) {
  const right = {};
  Object.entries(left).forEach(([k, v]) => {
    right[k] = [Math.round((100 - v[0] - v[2]) * 100) / 100, v[1], v[2], v[3]];
  });
  return right;
}

export const TAB_COORDS = {
  LBP: { left: LBP_L, right: mirrorCoords(LBP_L) },
  HIP: { left: HIP_L, right: mirrorCoords(HIP_L) },
  THIGH: { left: THIGH_L, right: mirrorCoords(THIGH_L) },
  KNEE: { left: KNEE_L, right: mirrorCoords(KNEE_L) },
};

// ═══════════════════════════════════════════════════════
// Highlight type classifications and helpers
// ═══════════════════════════════════════════════════════
const FULL_ZONES = ['Lower Back', 'Buttock', 'Thigh', 'Lower Leg', 'Knee', 'Back'];
const SPLIT_ZONES = ['Front/Groin', 'Back Thigh', 'Front Thigh', 'Front Knee', 'Back Knee'];
const EDGE_ZONES = ['Side Hip', 'Hip', 'Inner Thigh', 'Outer Thigh', 'Inner Knee', 'Outer Knee'];

export function hlType(z) {
  return EDGE_ZONES.includes(z) ? 'edge' : SPLIT_ZONES.includes(z) ? 'split' : 'full';
}
export function splitHalf(z) {
  return z.startsWith('Back') ? 'upper' : 'lower';
}
export function edgeSide(z) {
  if (z === 'Side Hip' || z === 'Hip' || z.startsWith('Outer')) return 'outer';
  return 'inner';
}

export const CLINICAL_PATHS = {
  LBP: {
    name: "Lower Back",
    zones: ZONE_BUTTONS.LBP,
  },
  HIP: {
    name: "Hip",
    zones: ZONE_BUTTONS.HIP,
    overrideTarget: 'PELVIC_CONTROL_IMPAIRMENT',
    cpgQuestion: {
      prompt: "Which of these best describes your primary hip complaint?",
      options: [
        {
          id: "hip-cpg-mobility",
          label: "A feeling of stiffness, tightness, or a block in movement.",
          value: "HIP_MOBILITY_DEFICITS",
          cpgForBackend: "Hip Pain with Mobility Deficits",
          routesTo: "subtypeQuestion",
          subtypeQuestionIndex: 0,
        },
        {
          id: "hip-cpg-power",
          label: "A feeling of weakness, fatigue, or that the hip might 'give out'.",
          value: "HIP_MUSCLE_POWER_DEFICITS",
          cpgForBackend: "Hip Pain with Muscle Power Deficits",
          routesTo: "subtypeQuestion",
          subtypeQuestionIndex: 1,
        },
        {
          id: "hip-cpg-motor",
          label: "A pinching, clicking, or catching feeling deep in the front of the hip.",
          value: "HIP_IMPAIRED_MOTOR_CONTROL",
          cpgForBackend: "Hip Pain with Impaired Motor Control",
          routesTo: "direct",
          directSubtype: "PELVIC_CONTROL_IMPAIRMENT",
        },
      ],
    },
    subtypeQuestions: [
      // Index 0: Mobility Deficits subtype question
      // CONSOLIDATED: Options C and E now route to POSTERIOR_CHAIN_MOBILITY_DEFICIT
      {
        prompt: "Where do you feel the tightness the most?",
        options: [
          {
            id: "hip-sub-lateral",
            label: "On the side of my hip, especially when lying on that side or walking.",
            value: "HIP_ABDUCTION_EXTERNAL_ROTATION_CONTROL_DEFICIT"  // Routes to glute/abductor program
          },
          {
            id: "hip-sub-anterior",
            label: "In the front of my hip or groin, especially when extending my leg behind me.",
            value: "ANTERIOR_CHAIN_MOBILITY_DEFICIT"
          },
          {
            id: "hip-sub-posterior",
            label: "In my buttock or the back of my hip, especially when bringing my knee towards my chest.",
            value: "POSTERIOR_CHAIN_MOBILITY_DEFICIT"
          },
          {
            id: "hip-sub-rotational",
            label: "In my groin or the crease where my leg meets my body, especially with twisting or crossing my legs.",
            value: "POSTERIOR_CHAIN_MOBILITY_DEFICIT",  // CONSOLIDATED: was ROTATIONAL_AND_IMPINGEMENT_DEFICIT
            displayLabel: "Rotational Mobility",  // For analytics/display if needed
          },
          {
            id: "hip-sub-neuro",
            label: "A specific, deep pain in my buttock, sometimes with tingling down my leg.",
            value: "NEUROMUSCULAR_MOBILITY_DEFICIT"
          },
          {
            id: "hip-sub-global",
            label: "A general, deep ache and stiffness all around the joint, worse in the morning.",
            value: "POSTERIOR_CHAIN_MOBILITY_DEFICIT",  // CONSOLIDATED: was GLOBAL_MOBILITY_DEFICIT
            displayLabel: "General Hip Mobility",  // For analytics/display if needed
          },
        ],
      },
      // Index 1: Muscle Power Deficits subtype question
      {
        prompt: "Which activity is most difficult or brings on your symptoms?",
        options: [
          {
            id: "hip-sub-adductor",
            label: "Moving my legs apart or a feeling of strain in my inner thigh/groin.",
            value: "ADDUCTOR_OVERLOAD_CONTROL_DEFICIT"
          },
          {
            id: "hip-sub-abduction",
            label: "Standing on one leg, climbing stairs, or feeling my hip drop when I walk.",
            value: "HIP_ABDUCTION_EXTERNAL_ROTATION_CONTROL_DEFICIT"
          },
        ],
      },
    ],
    // UPDATED: Removed entries for consolidated subtypes
    testMap: {
      ANTERIOR_CHAIN_MOBILITY_DEFICIT: { name: "Standing Hip Flexor Stretch", video: PLACEHOLDER_VIDEO },
      POSTERIOR_CHAIN_MOBILITY_DEFICIT: { name: "Seated Glute Stretch", video: PLACEHOLDER_VIDEO },
      NEUROMUSCULAR_MOBILITY_DEFICIT: { name: "Seated Glute Stretch", video: PLACEHOLDER_VIDEO },
      ADDUCTOR_OVERLOAD_CONTROL_DEFICIT: { name: "Seated Hip Hinge", video: PLACEHOLDER_VIDEO },
      HIP_ABDUCTION_EXTERNAL_ROTATION_CONTROL_DEFICIT: { name: "Seated Hip Abduction", video: PLACEHOLDER_VIDEO },
      PELVIC_CONTROL_IMPAIRMENT: { name: "Seated Hip Hinge", video: PLACEHOLDER_VIDEO },
    },
    negativeTestMap: {
      ANTERIOR_CHAIN_MOBILITY_DEFICIT: { name: "Standing Hip Extension", video: PLACEHOLDER_VIDEO },
      POSTERIOR_CHAIN_MOBILITY_DEFICIT: { name: "Seated Single Knee to Chest", video: PLACEHOLDER_VIDEO },
      NEUROMUSCULAR_MOBILITY_DEFICIT: { name: "Toe Touch", video: PLACEHOLDER_VIDEO },
      ADDUCTOR_OVERLOAD_CONTROL_DEFICIT: { name: "Lateral Lunge", video: PLACEHOLDER_VIDEO },
      HIP_ABDUCTION_EXTERNAL_ROTATION_CONTROL_DEFICIT: { name: "Standing Hip Abduction", video: PLACEHOLDER_VIDEO },
      PELVIC_CONTROL_IMPAIRMENT: { name: "Squat", video: PLACEHOLDER_VIDEO },
    },
  },
  THIGH: {
    name: "Thigh",
    zones: ZONE_BUTTONS.THIGH,
    overrideTarget: 'HAMSTRING_LOADING_LENGTHENING_DEFICIT',  // CHANGED: was NERVE_GLIDING_DYSFUNCTION
    cpgQuestion: {
      prompt: "Which of these best describes the feeling in your thigh?",
      options: [
        {
          id: "thigh-cpg-muscular",
          label: "A muscular ache, pull, or strain.",
          value: "THIGH_MUSCULAR_ORIGIN",
          cpgForBackend: "Thigh Pain with Muscular Origin",
          routesTo: "subtypeQuestion",
          subtypeQuestionIndex: 0,
        },
        {
          id: "thigh-cpg-neural",
          label: "A burning, tingling, or 'pins and needles' feeling.",
          value: "THIGH_NEURAL_INVOLVEMENT",
          cpgForBackend: "Thigh Pain with Muscular Origin",
          routesTo: "direct",
          directSubtype: "HAMSTRING_LOADING_LENGTHENING_DEFICIT",  // CONSOLIDATED: was NERVE_GLIDING_DYSFUNCTION
          displayLabel: "Neural Involvement",
        },
        {
          id: "thigh-cpg-referred",
          label: "A vague, deep ache that seems to come from my back or hip.",
          value: "THIGH_REFERRED_SYMPTOMS",
          cpgForBackend: "Thigh Pain with Muscular Origin",  // Routes to muscular CPG for exercise matching
          routesTo: "direct",
          directSubtype: "HAMSTRING_LOADING_LENGTHENING_DEFICIT",  // CONSOLIDATED: was LUMBAR_HIP_REFERRED_MOVEMENT
          displayLabel: "Referred Symptoms",
        },
      ],
    },
    subtypeQuestions: [
      // Index 0: Muscular Origin subtype question (location-based)
      {
        prompt: "Where in your thigh do you feel it the most?",
        options: [
          {
            id: "thigh-sub-anterior",
            label: "The front of my thigh.",
            value: "QUADRICEPS_LOADING_IMPACT_INTOLERANCE"
          },
          {
            id: "thigh-sub-medial",
            label: "The inner thigh or groin area.",
            value: "ADDUCTOR_OVERLOAD_CONTROL_DEFICIT"
          },
          {
            id: "thigh-sub-posterior",
            label: "The back of my thigh.",
            value: "HAMSTRING_LOADING_LENGTHENING_DEFICIT"
          },
          {
            id: "thigh-sub-lateral",
            label: "The outer (lateral) side of my thigh.",
            value: "ITB_FRICTION_SYNDROME"
          },
        ],
      },
    ],
    testMap: {
      QUADRICEPS_LOADING_IMPACT_INTOLERANCE: { name: "Seated Isometric Knee Extension", video: PLACEHOLDER_VIDEO },
      ADDUCTOR_OVERLOAD_CONTROL_DEFICIT: { name: "Seated Hip Hinge", video: PLACEHOLDER_VIDEO },
      HAMSTRING_LOADING_LENGTHENING_DEFICIT: { name: "Toe Touch", video: PLACEHOLDER_VIDEO },
      ITB_FRICTION_SYNDROME: { name: "Standing ITB Stretch - Side Bend", video: PLACEHOLDER_VIDEO },
    },
    negativeTestMap: {
      QUADRICEPS_LOADING_IMPACT_INTOLERANCE: { name: "Sit to Stand", video: PLACEHOLDER_VIDEO },
      ADDUCTOR_OVERLOAD_CONTROL_DEFICIT: { name: "Lateral Lunge", video: PLACEHOLDER_VIDEO },
      HAMSTRING_LOADING_LENGTHENING_DEFICIT: { name: "Sit to Stand", video: PLACEHOLDER_VIDEO },
      ITB_FRICTION_SYNDROME: { name: "Standing ITB Stretch - Toe Touch", video: PLACEHOLDER_VIDEO },
    },
  },
  KNEE: {
    name: "Knee",
    zones: ZONE_BUTTONS.KNEE,
    overrideTarget: 'LIMITED_KNEE_EXTENSION_FLEXION_MOBILITY',
    cpgQuestion: {
      prompt: "Which of these best describes where you feel your knee pain?",
      options: [
        {
          id: "knee-cpg-pfp",
          label: "Around or behind my kneecap.",
          value: "KNEE_PATELLOFEMORAL",
          cpgForBackend: "Patellofemoral Pain (PFP)",
          routesTo: "subtypeQuestion",
          subtypeQuestionIndex: 0,
        },
        {
          id: "knee-cpg-mobility",
          label: "The entire joint feels stiff, blocked, or unstable.",
          value: "KNEE_MOBILITY_STABILITY",
          cpgForBackend: "Knee Pain with Mobility/Stability Deficits",
          routesTo: "subtypeQuestion",
          subtypeQuestionIndex: 1,
        },
        {
          id: "knee-cpg-lateral",
          label: "On the outer (lateral) side of my knee.",
          value: "KNEE_LATERAL",
          cpgForBackend: "Knee Pain with Lateral Symptoms",
          routesTo: "direct",
          directSubtype: "ITB_FRICTION_SYNDROME",
        },
        {
          id: "knee-cpg-posterior",
          label: "In the back of my knee, especially when bending or straightening.",
          value: "KNEE_POSTERIOR",
          cpgForBackend: "Knee Pain with Posterior Symptoms",
          routesTo: "direct",
          directSubtype: "HAMSTRING_LOADING_LENGTHENING_DEFICIT"
        },
        {
          id: "knee-cpg-medial",
          label: "On the inner (medial) side of my knee.",
          value: "KNEE_MEDIAL",
          cpgForBackend: "Knee Pain with Medial Symptoms",
          routesTo: "direct",
          directSubtype: "LIMITED_KNEE_EXTENSION_FLEXION_MOBILITY"
        },
      ],
    },
    subtypeQuestions: [
      // Index 0: Patellofemoral subtype question
      {
        prompt: "When do you notice the pain the most?",
        options: [
          {
            id: "knee-sub-valgus",
            label: "With activities like squatting or going down stairs, and I notice my knee tends to dive inward.",
            value: "KNEE_VALGUS_COLLAPSE"
          },
          {
            id: "knee-sub-maltrack",
            label: "With prolonged sitting, and I feel a grinding or clicking under the kneecap.",
            value: "PATELLOFEMORAL_PAIN_WITH_MALTRACKING"
          },
          {
            id: "knee-sub-tendon",
            label: "A sharp pain right below my kneecap, especially with jumping or running.",
            value: "QUADRICEPS_LOADING_IMPACT_INTOLERANCE"
          },
        ],
      },
      // Index 1: Mobility/Stability subtype question
      {
        prompt: "Which best describes your knee symptoms?",
        options: [
          {
            id: "knee-sub-stiff",
            label: "My knee feels stiff, and I can't fully bend or straighten it.",
            value: "LIMITED_KNEE_EXTENSION_FLEXION_MOBILITY"
          },
          {
            id: "knee-sub-unstable",
            label: "My knee feels like it might buckle, shift, or give way.",
            value: "TIBIAL_TRANSLATION_INSTABILITY"
          },
        ],
      },
    ],
    testMap: {
      KNEE_VALGUS_COLLAPSE: { name: "Seated Hip Abduction", video: PLACEHOLDER_VIDEO },
      PATELLOFEMORAL_PAIN_WITH_MALTRACKING: { name: "Seated Isometric Knee Extension", video: PLACEHOLDER_VIDEO },
      QUADRICEPS_LOADING_IMPACT_INTOLERANCE: { name: "Seated Isometric Knee Extension", video: PLACEHOLDER_VIDEO },
      LIMITED_KNEE_EXTENSION_FLEXION_MOBILITY: { name: "Seated Isometric Knee Extension", video: PLACEHOLDER_VIDEO },
      TIBIAL_TRANSLATION_INSTABILITY: { name: "Seated Isometric Knee Extension", video: PLACEHOLDER_VIDEO },
      ITB_FRICTION_SYNDROME: { name: "Standing ITB Stretch - Side Bend", video: PLACEHOLDER_VIDEO },
      HAMSTRING_LOADING_LENGTHENING_DEFICIT: { name: "Toe Touch", video: PLACEHOLDER_VIDEO },
    },
    negativeTestMap: {
      KNEE_VALGUS_COLLAPSE: { name: "Squat", video: PLACEHOLDER_VIDEO },
      PATELLOFEMORAL_PAIN_WITH_MALTRACKING: { name: "Seated Squat", video: PLACEHOLDER_VIDEO },
      QUADRICEPS_LOADING_IMPACT_INTOLERANCE: { name: "Sit to Stand", video: PLACEHOLDER_VIDEO },
      LIMITED_KNEE_EXTENSION_FLEXION_MOBILITY: { name: "Seated Squat", video: PLACEHOLDER_VIDEO },
      TIBIAL_TRANSLATION_INSTABILITY: { name: "Seated Squat", video: PLACEHOLDER_VIDEO },
      ITB_FRICTION_SYNDROME: { name: "Squat", video: PLACEHOLDER_VIDEO },
      HAMSTRING_LOADING_LENGTHENING_DEFICIT: { name: "Sit to Stand", video: PLACEHOLDER_VIDEO },
    },
  },
  // SHOULDER: {
  //   name: "Shoulder",
  //   zones: [
  //     { id: "SHOULDER_ANTERIOR", name: "Anterior Shoulder", style: { width: "40px", height: "40px", top: "120px", left: "90px" } },
  //     { id: "SHOULDER_LATERAL", name: "Lateral Shoulder", style: { width: "40px", height: "50px", top: "120px", left: "60px" } },
  //     { id: "SHOULDER_POSTERIOR", name: "Posterior Shoulder", style: { width: "40px", height: "40px", top: "120px", left: "140px" } },
  //     { id: "SHOULDER_SUPERIOR", name: "Superior Shoulder", style: { width: "50px", height: "30px", top: "100px", left: "100px" } },
  //   ],
  // },
};

export const compassLevelNames = {
  1: "Foundational Awareness",
  2: "Foundational Mobility",
  3: "Core Activation & Mobility",
  4: "Introductory Strengthening",
  5: "Progressive Strengthening",
};
export const CPG_OPTIONS = [
  {
    id: "cpg-radiating",
    label: "A sharp, shooting pain that feels like a narrow line.",
    value: "LBP with Radiating Pain (Radiculopathy)",
  },
  {
    id: "cpg-referred",
    label: "A more spread out, dull, or deep ache.",
    value: "LBP with Related (Referred) Lower Extremity Pain",
  },
  {
    id: "cpg-unsure-leg",
    label: "Both / Not Sure",
    value: "LBP with Related (Referred) Lower Extremity Pain",
  },
];

export const BACK_CPG_OPTIONS = [
  {
    id: "cpg-mobility",
    label: "A feeling of deep, stiff aching and restricted movement.",
    value: "LBP with Mobility Deficits",
  },
  {
    id: "cpg-coordination",
    label: 'A feeling of instability, weakness, or the back "giving out".',
    value: "LBP with Movement Coordination Impairments",
  },
  {
    id: "cpg-unsure-back",
    label: "Both / Not Sure",
    value: "LBP with Movement Coordination Impairments",
  },
];

export const testMap = {
  FLEXION_INTOLERANT: {
    name: "Standing Lumbar Extension",
    video: StandingLumbarExtension,
  },
  EXTENSION_INTOLERANT: {
    name: "Supine Double Knee to Chest",
    video: SupineDoubleKneeToChest,
  },
  NEUTRAL_SENSITIVE: {
    name: "Seated Trunk Rotation",
    video: SeatedTrunkRotation,
  },
  LIMITED_LUMBAR_MOBILITY: {
    name: "Side to Side Bend",
    video: StandingSideBend,
  },
  ROTATIONAL_INTOLERANT: { name: "Standing Lumbar Extension", video: StandingLumbarExtension },
  SUBSTITUTE_TEST_1: {
    name: "Seated Single Knee to Chest",
    video: SeatedSingleKneeToChest,
  },
};

export const negativeTestMap = {
  FLEXION_INTOLERANT: {
    name: "Toe Touch",
    video: ToeTouchNeg,
  },
  EXTENSION_INTOLERANT: {
    name: "Prone Press Up",
    // video: StandingLumbarExtensionNeg,
    video: PronePressUpNeg,
  },
  LIMITED_LUMBAR_MOBILITY: {
    name: "Seated Trunk Rotation",
    video: SeatedTrunkRotationNeg,
  },
  ROTATIONAL_INTOLERANT: {
    name: "Seated Trunk Rotation",
    video: SeatedTrunkRotation
  },
  // Modified for Floor & Attributes on Aug 10th 2025
  SUBSTITUTE_TEST_2: {
    name: "Standing Lumbar Extension",
    video: StandingLumbarExtensionNeg, // Using its own video
  },
};

export const testSpecificIntroVideos = {
  "Standing Lumbar Extension": "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/IntroToAR-StandingLumbarExtension-v1.0.mp4",
  "Supine Double Knee to Chest": "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/IntroToAR-SupineDoubleKneeToChest-v1.0.mp4",
  "Seated Trunk Rotation": "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/IntroToAR-SeatedTrunkRotation-v1.0.mp4",
  "Side to Side Bend": "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/IntroToAR-SideToSideBend-v1.0.mp4",
  "Seated Single Knee to Chest": "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/GSA-SeatedSingleKneeToChest-Neg.mp4",
  "Toe Touch": "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/ToeTouchNegativeTestv1.0.mp4",
  "Seated Hip Abduction":
    "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/GSA-SeatedHipAbduction.mp4",

  "Squat":
    "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/GSA-Squat-Neg.mp4",

  "Seated Squat":
    "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/GSA-SeatedSquat-Neg.mp4",

  "Sit to Stand":
    "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/GSA-SitToStand-Neg.mp4",

  "Seated Isometric Knee Extension":
    "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/GSA-SeatedIsometricKneeExtension.mp4",

  "Seated Hip Hinge":
    "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/GSA-SeatedHipHinge.mp4",

  "Standing Hip Abduction":
    "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/GSA-StandingHipAbduction-Neg.mp4",

  "Standing Hip Extension":
    "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/GSA-StandingHipExtension-Neg.mp4",

  "Standing Hip Flexor Stretch":
    "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/GSA-StandingHipFlexorStretch.mp4",

  "Seated Glute Stretch":
    "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/GSA-SeatedGluteStretch.mp4",

  "Lateral Lunge":
    "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/GSA-LateralLunge-Neg.mp4",

  "Standing ITB Stretch - Side Bend":
    "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/GSA-StandingITBStretch-SideBend.mp4",

  "Standing ITB Stretch - Toe Touch":
    "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/GSA-StandingITBStretch-ToeTouch-Neg.mp4",
};

export const DEFAULT_INTRO_VIDEO = "https://virdiodev.s3.us-east-2.amazonaws.com/self_media/VH-ARTargetExplanationv1.0.mp4";

export const activityLevels = [
  { id: "activity-sedentary", value: "SEDENTARY", label: "0 days", tabIndex: 5 },
  { id: "activity-light", value: "LIGHTLY_ACTIVE", label: "1-2 days", tabIndex: 6 },
  { id: "activity-active", value: "ACTIVE", label: "3-4 days", tabIndex: 7 },
  { id: "activity-very-active", value: "VERY_ACTIVE", label: "5+ days", tabIndex: 8 },
];

// export const scheduleDays = [
//   { id: "days-2-3", value: "2-3", label: "2-3" },
//   { id: "days-3-4", value: "3-4", label: "3-4" },
//   { id: "days-5-plus", value: "5+", label: "5+" },
// ];

// export const scheduleTimes = [
//   { id: "time-10-15", value: "10-15", label: "10-15 min" },
//   { id: "time-15-20", value: "15-20", label: "15-20 min" },
//   { id: "time-20-30", value: "20-30", label: "20-30 min" },
// ];

export const scheduleDaysOptions = [
  { id: "days-2", value: "2", label: "2", tabIndex: 14 },
  { id: "days-3", value: "3", label: "3", tabIndex: 15 },
  { id: "days-4", value: "4", label: "4", tabIndex: 16 },
  { id: "days-5", value: "5", label: "5", tabIndex: 17 },
  { id: "days-6", value: "6", label: "6", tabIndex: 18 },
  { id: "days-7", value: "7", label: "7", tabIndex: 19 },
];

export const scheduleTimeOptions = [
  { id: "time-10", value: "10", label: "10 min", tabIndex: 22 },
  { id: "time-15", value: "15", label: "15 min", tabIndex: 23 },
  { id: "time-20", value: "20", label: "20 min", tabIndex: 24 },
];

// Modified for Floor & Attributes on Aug 10th 2025
export const floorOptions = [
  { id: "capability-floor-yes", value: "yes", label: "Yes, I am comfortable", tabIndex: 9 },
  { id: "capability-floor-no", value: "no", label: "No, it is too difficult right now", tabIndex: 10 },
];

// Modified for Floor & Attributes on Aug 10th 2025
export const balanceOptions = [
  { id: "balance-steady", value: "steady", label: "Steady", tabIndex: 11 },
  { id: "balance-mixed", value: "unsteady", label: "Steady & Unsteady", tabIndex: 12 },
];

// Modified for Floor & Attributes on Aug 10th 2025
export const goalOptions = [
  { id: "goal-stand-walk", value: "stand_walk", label: "Improve my ability to stand and walk" },
  { id: "goal-strength", value: "strength", label: "Increase my overall strength" },
];

// Modified for Floor & Attributes on Aug 10th 2025
export const sessionOptions = [
  { id: "session-one", value: "one", label: "One Session", tabIndex: 20 },
  { id: "session-multiple", value: "multiple", label: "Two Sessions", tabIndex: 21 },
];

export const messaging = {
  // Sourced from the isolated prototype's data
  diagnosis: {
    LIMITED_LUMBAR_MOBILITY: {
      headline: "Your Back Pain May Be Caused by Stiffness",
      clinicalTerm: "Limited Lumbar Mobility",
      implications: "Because your lower back isn't moving as freely as it could, you might find that activities like putting on your shoes, getting out of a car, or twisting to reach for something feel stiff and difficult.",
      relief: "Gentle Movement In All Directions May Provide Relief",
    },
    NEUTRAL_SENSITIVE: {
      headline: "Your Back Seems to Want More Support",
      clinicalTerm: "Movement Coordination Impairments",
      implications: 'You might notice that your back feels weak, unstable, or like it might "give out." Changing positions frequently may be your best source of relief right now.',
      relief: "Changing Positions Frequently May Be Your Best Source Of Relief Right Now",
    },
    FLEXION_INTOLERANT: {
      headline: "Your Back Dislikes Bending Forward",
      clinicalTerm: "Flexion Intolerance",
      implications: "Activities that involve rounding your lower back, like slouching or tying your shoes, are likely to increase your discomfort. You may find that standing or gently arching your back provides relief.",
      relief: "You May Find That Standing Or Arching Your Back Provides Relief",
    },
    EXTENSION_INTOLERANT: {
      headline: "Your Back Dislikes Arching or Extended Standing",
      clinicalTerm: "Extension Intolerance",
      implications: "You might find that prolonged standing or walking is uncomfortable, and that sitting or slouching provides relief.",
      relief: "You May Find That Sitting Or Slouching Provides Relief",
    },
    ROTATIONAL_INTOLERANT: {
      headline: "Your Back Dislikes Twisting",
      clinicalTerm: "Rotational Intolerance",
      implications: "You might find that movements involving twisting, turning, or reaching across your body increase your discomfort. Turning your whole body instead of just your back during these activities may help.",
      relief: "Minimizing Twisting Motions May Provide Relief",
    },
    HIGH_FUNCTIONING: {
      headline: "Your Back Is Ready to Level Up",
      clinicalTerm: "High Functioning / Low Irritability",
      implications: "You’veshown strong control and minimal symptoms during the assessment, so you are well-positioned to progress beyond basic exercises and build a stronger, more durable back.",
      relief: "You May Find That Standing Or Arching Your Back Provides Relief",
    },
    ANTERIOR_CHAIN_MOBILITY_DEFICIT: {
      headline: "Your Hip Pain May Be Related to Tight Hip Flexors",
      clinicalTerm: "Anterior Chain Mobility Deficit",
      implications: "You might find that extending your leg behind you, standing up after prolonged sitting, or walking uphill increases your discomfort.",
      relief: "Hip Flexor Stretching May Provide Relief",
    },
    POSTERIOR_CHAIN_MOBILITY_DEFICIT: {
      headline: "Your Hip Pain May Be Related to Tight Posterior Muscles",
      clinicalTerm: "Posterior Chain Mobility Deficit",
      implications: "You might find that bringing your knee toward your chest, sitting for long periods, or certain rotational movements increase your discomfort.",
      relief: "Glute and Hip Mobility Work May Provide Relief",
    },
    NEUROMUSCULAR_MOBILITY_DEFICIT: {
      headline: "Your Hip Pain May Have a Neural Component",
      clinicalTerm: "Neuromuscular Mobility Deficit",
      implications: "You might notice a deep, specific pain in your buttock that sometimes travels down your leg, especially with certain sitting positions.",
      relief: "Gentle Neural Mobilization May Provide Relief",
    },
    ADDUCTOR_OVERLOAD_CONTROL_DEFICIT: {
      headline: "Your Pain May Be Related to Inner Thigh Muscles",
      clinicalTerm: "Adductor Overload/Control Deficit",
      implications: "You might find that moving your legs apart, side-stepping, or activities that stress your inner thigh increase your discomfort.",
      relief: "Inner Thigh Strengthening May Provide Relief",
    },
    HIP_ABDUCTION_EXTERNAL_ROTATION_CONTROL_DEFICIT: {
      headline: "Your Hip May Need Better Side Support",
      clinicalTerm: "Hip Abduction/External Rotation Control Deficit",
      implications: "You might notice your hip drops when walking, or you feel unsteady when standing on one leg or climbing stairs.",
      relief: "Hip Abductor Strengthening May Provide Relief",
    },
    PELVIC_CONTROL_IMPAIRMENT: {
      headline: "Your Hip Needs Better Pelvic Control",
      clinicalTerm: "Pelvic Control Impairment",
      implications: "You might notice a pinching, clicking, or catching feeling in the front of your hip during certain movements, or feel like your pelvis isn't stable.",
      relief: "Pelvic Stability Exercises May Provide Relief",
    },

    // --- THIGH SUBTYPES (4 after consolidation) ---
    QUADRICEPS_LOADING_IMPACT_INTOLERANCE: {
      headline: "Your Thigh Pain May Be Related to Quadriceps Loading",
      clinicalTerm: "Quadriceps Loading/Impact Intolerance",
      implications: "You might find that activities like running, jumping, going down stairs, or kicking increase your front thigh discomfort.",
      relief: "Progressive Quadriceps Loading May Provide Relief",
    },
    HAMSTRING_LOADING_LENGTHENING_DEFICIT: {
      headline: "Your Thigh Pain May Be Related to Hamstring or Posterior Chain",
      clinicalTerm: "Hamstring Loading/Lengthening Deficit",
      implications: "You might find that bending forward, stretching, quick movements, or prolonged sitting increase your thigh discomfort.",
      relief: "Progressive Hamstring Work May Provide Relief",
    },
    ITB_FRICTION_SYNDROME: {
      headline: "Your Pain May Be Related to IT Band Tightness",
      clinicalTerm: "ITB Friction Syndrome",
      implications: "You might notice pain on the outer side of your thigh or knee, especially with repetitive activities like running or cycling.",
      relief: "IT Band Stretching and Hip Strengthening May Provide Relief",
    },
    // Note: ADDUCTOR_OVERLOAD_CONTROL_DEFICIT uses same messaging as HIP version

    // --- KNEE SUBTYPES (6 unchanged) ---
    KNEE_VALGUS_COLLAPSE: {
      headline: "Your Knee Pain May Be Related to Inward Knee Motion",
      clinicalTerm: "Knee Valgus Collapse",
      implications: "You might notice your knee diving inward during squats, stairs, or landing from jumps.",
      relief: "Hip Strengthening to Control Knee Position May Provide Relief",
    },
    PATELLOFEMORAL_PAIN_WITH_MALTRACKING: {
      headline: "Your Knee Pain May Be Related to Kneecap Tracking",
      clinicalTerm: "Patellofemoral Pain with Maltracking",
      implications: "You might notice grinding, clicking, or pain under your kneecap, especially after prolonged sitting.",
      relief: "Quadriceps Control and Patellar Tracking Exercises May Provide Relief",
    },
    LIMITED_KNEE_EXTENSION_FLEXION_MOBILITY: {
      headline: "Your Knee May Need Better Mobility",
      clinicalTerm: "Limited Knee Extension/Flexion Mobility",
      implications: "You might find it difficult to fully straighten or bend your knee, with stiffness throughout the range.",
      relief: "Gentle Range of Motion Exercises May Provide Relief",
    },
    TIBIAL_TRANSLATION_INSTABILITY: {
      headline: "Your Knee May Feel Unstable",
      clinicalTerm: "Tibial Translation (Instability)",
      implications: "You might feel like your knee could buckle, shift, or give way during activities.",
      relief: "Controlled Strengthening to Improve Stability May Provide Relief",
    },
  },
  readinessTiers: {
    READY_TO_GO: {
      headline: "Ready to Go",
      description: "Your history and health factors show you're ready for a standard starting intensity.",
    },
    CAUTIOUS_START: {
      headline: "A Cautious Start",
      description: "We've slightly adjusted the intensity of your plan to ensure your body adapts well as you get started.",
    },
    GENTLE_APPROACH: {
      headline: "A Gentle Approach",
      description: "We've adjusted your plan to begin with a gentler intensity, giving your body extra time to respond and build momentum safely.",
    },
    STARTING_WITH_CARE: {
      headline: "Starting with Care",
      description: "To ensure the safest start, your plan begins with a very gentle intensity, focused on building a solid foundation.",
    },
  },
  planFocus: {
    FLEXION_INTOLERANT: "Reduce Sensitivity to Bending",
    EXTENSION_INTOLERANT: "Relieve Pressure from Arching",
    LIMITED_LUMBAR_MOBILITY: "Improve Flexibility",
    NEUTRAL_SENSITIVE: "Build Core Support",
    ROTATIONAL_INTOLERANT: "Reduce Sensitivity to Twisting",
    // HIP
    ANTERIOR_CHAIN_MOBILITY_DEFICIT: "Improve Hip Flexor Flexibility",
    POSTERIOR_CHAIN_MOBILITY_DEFICIT: "Improve Hip Mobility",
    NEUROMUSCULAR_MOBILITY_DEFICIT: "Address Neural Tension",
    ADDUCTOR_OVERLOAD_CONTROL_DEFICIT: "Strengthen Inner Thigh Control",
    HIP_ABDUCTION_EXTERNAL_ROTATION_CONTROL_DEFICIT: "Strengthen Hip Abductors",
    PELVIC_CONTROL_IMPAIRMENT: "Improve Pelvic Stability",

    // THIGH
    QUADRICEPS_LOADING_IMPACT_INTOLERANCE: "Build Quadriceps Tolerance",
    HAMSTRING_LOADING_LENGTHENING_DEFICIT: "Improve Posterior Chain Flexibility",
    ITB_FRICTION_SYNDROME: "Release IT Band Tension",

    // KNEE 
    KNEE_VALGUS_COLLAPSE: "Control Knee Alignment",
    PATELLOFEMORAL_PAIN_WITH_MALTRACKING: "Improve Kneecap Tracking",
    LIMITED_KNEE_EXTENSION_FLEXION_MOBILITY: "Restore Knee Range of Motion",
    TIBIAL_TRANSLATION_INSTABILITY: "Build Knee Stability",
  },
};
export const DIAGNOSTIC_CERTAINTY_SCORES = {
  // LBP (existing - no changes)
  FLEXION_INTOLERANT: 20,
  EXTENSION_INTOLERANT: 20,
  LIMITED_LUMBAR_MOBILITY: 20,
  ROTATIONAL_INTOLERANT: 20,
  NEUTRAL_SENSITIVE: 10,
  HIGH_FUNCTIONING: 20,

  // HIP (6 subtypes after consolidation)
  ANTERIOR_CHAIN_MOBILITY_DEFICIT: 20,
  POSTERIOR_CHAIN_MOBILITY_DEFICIT: 20,  // Now includes rotational and global
  NEUROMUSCULAR_MOBILITY_DEFICIT: 10,
  ADDUCTOR_OVERLOAD_CONTROL_DEFICIT: 20,
  HIP_ABDUCTION_EXTERNAL_ROTATION_CONTROL_DEFICIT: 20,
  PELVIC_CONTROL_IMPAIRMENT: 10,  // Override target

  // THIGH (4 subtypes after consolidation)
  QUADRICEPS_LOADING_IMPACT_INTOLERANCE: 20,
  HAMSTRING_LOADING_LENGTHENING_DEFICIT: 20,  // Now includes neural and referred
  ITB_FRICTION_SYNDROME: 20,

  // KNEE (6 subtypes unchanged)
  KNEE_VALGUS_COLLAPSE: 10,
  PATELLOFEMORAL_PAIN_WITH_MALTRACKING: 20,
  LIMITED_KNEE_EXTENSION_FLEXION_MOBILITY: 20,
  TIBIAL_TRANSLATION_INSTABILITY: 10,
};
// Purpose: Unified lookup across all problem areas
// ============================================================
export const getFirstTestForSubtype = (problemArea, subtype) => {
  const path = CLINICAL_PATHS[problemArea];
  if (!path || !path.testMap) return null;
  return path.testMap[subtype] || null;
};

export const getSecondTestForSubtype = (problemArea, subtype) => {
  const path = CLINICAL_PATHS[problemArea];
  if (!path || !path.negativeTestMap) return null;
  return path.negativeTestMap[subtype] || null;
};

export const getOverrideTarget = (problemArea) => {
  const path = CLINICAL_PATHS[problemArea];
  return path?.overrideTarget || null;
};

// Purpose: Map frontend subtype codes to backend CPG strings
// ============================================================
export const SUBTYPE_TO_CPG_MAP = {
  HIP: {
    ANTERIOR_CHAIN_MOBILITY_DEFICIT: "Hip Pain with Mobility Deficits",
    POSTERIOR_CHAIN_MOBILITY_DEFICIT: "Hip Pain with Mobility Deficits",
    NEUROMUSCULAR_MOBILITY_DEFICIT: "Hip Pain with Mobility Deficits",
    ADDUCTOR_OVERLOAD_CONTROL_DEFICIT: "Hip Pain with Muscle Power Deficits",
    HIP_ABDUCTION_EXTERNAL_ROTATION_CONTROL_DEFICIT: "Hip Pain with Muscle Power Deficits",
    PELVIC_CONTROL_IMPAIRMENT: "Hip Pain with Impaired Motor Control",
  },
  THIGH: {
    QUADRICEPS_LOADING_IMPACT_INTOLERANCE: "Thigh Pain with Muscular Origin",
    ADDUCTOR_OVERLOAD_CONTROL_DEFICIT: "Thigh Pain with Muscular Origin",
    HAMSTRING_LOADING_LENGTHENING_DEFICIT: "Thigh Pain with Muscular Origin",
    ITB_FRICTION_SYNDROME: "Thigh Pain with Muscular Origin",
  },
  KNEE: {
    KNEE_VALGUS_COLLAPSE: "Patellofemoral Pain (PFP)",
    PATELLOFEMORAL_PAIN_WITH_MALTRACKING: "Patellofemoral Pain (PFP)",
    QUADRICEPS_LOADING_IMPACT_INTOLERANCE: "Knee Pain with Tendon Loading Deficits",
    LIMITED_KNEE_EXTENSION_FLEXION_MOBILITY: "Knee Pain with Mobility/Stability Deficits",
    TIBIAL_TRANSLATION_INSTABILITY: "Knee Pain with Mobility/Stability Deficits",
    ITB_FRICTION_SYNDROME: "Knee Pain with Lateral Symptoms",
  },
};